import { CarTypes, Market } from '../constants';

export function getStockIdentifierValues(
  isUsedVehicles: boolean,
  isUsMarket: boolean,
  lang: string,
) {
  return {
    stockCarsType: isUsedVehicles ? CarTypes.USED : CarTypes.NEW,
    marketIdentifier: {
      language: lang,
      country: isUsMarket ? Market.US : Market.CA,
      brand: 'A',
    },
  };
}
